import React from "react";

// mui imports
import { Box, Typography } from "@mui/material";
import FooterDownloadButtons from "./FooterDownloadButtons";
import { useSelector } from "react-redux";
import { selectTheme } from "../../../../store/reducers/theme";
import VaseelahLogo from "../../../../components/@extended/logos/VaseelahLogo";
import PriseenLogo from "../../../../components/@extended/logos/PriseenLogo";
import useBreakpoint from "../../../../hooks/useBreakpoint";

export default function FooterUpper() {
  const { resolvedMode } = useSelector(selectTheme);
  const breakpoint = useBreakpoint();
  return (
    <div className="flex flex-col lg:flex-row justify-between">
      <Box className="flex gap-[10px]" id="footer-description">
        <Box className="w-[250px] flex flex-col gap-[20px]">
          {/* <img
            src="assets/images/logos/priseen-white.svg"
            alt="vaeelah-logo"
            width={120}
          /> */}

          <PriseenLogo
            white={resolvedMode === "dark" ? true : false}
            width={["xs", "sm"].includes(breakpoint) && 100}
          />
          <Typography className="text-primary text-[13px] lg:text-[14px]">
            Priseen® is set to transform how businesses and consumers
            collaborate.
          </Typography>
        </Box>
        <Box className="w-[250px] flex flex-col gap-[10px]">
          {/* <img
            src="assets/images/logos/vaseelah-logo-white.svg"
            alt="vaeelah-logo"
            width={120}
          /> */}
          <a target="_blank" className="" href="https://www.vaseelah.com">
            <VaseelahLogo
              white={resolvedMode === "dark" ? true : false}
              width={["xs", "sm"].includes(breakpoint) && 80}
            />
          </a>

          <Typography className="text-primary font-normal text-[13px] lg:text-[14px]">
            Vaseelah (a platform by Priseen Solution) simplifies humanitarian
            logistics through technology, ensuring faster, more efficient aid
            delivery.
          </Typography>
        </Box>
      </Box>
      {/* <FooterDownloadButtons /> */}
    </div>
  );
}
